import FormattedMessage from 'I18n/components/FormattedMessage';
import { Text } from 'foundations-components/components/Text';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// The "1/n" label is only present for multi-step tours, however, this tour is a single step
// We can simply make a "1/1" string and style it to achieve the desired result
export const StyledMarker = () => {
  return /*#__PURE__*/_jsx(Text, {
    typography: "detail-100",
    marginBlockStart: "500",
    marginBlockEnd: "100",
    textAlign: "center",
    children: "1/1"
  });
};
const ForecastTypeSelectorConfig = {
  id: 'forecast-type-selector-coaching-tips',
  tips: [{
    attachTo: '[data-coaching-tip="forecast-type-selector"]',
    placement: 'right top',
    popoverPlacement: 'right',
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "forecastingCoachingTips.fmoOnboarding.forecastTypeDropdown.title"
    }),
    steps: [{
      content: /*#__PURE__*/_jsxs(Text, {
        textAlign: "center",
        children: [/*#__PURE__*/_jsx(FormattedMessage, {
          message: "forecastingCoachingTips.fmoOnboarding.forecastTypeDropdown.body"
        }), /*#__PURE__*/_jsx(StyledMarker, {})]
      })
    }]
  }]
};
export default ForecastTypeSelectorConfig;